import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  isLogin: false,
  loading: false,
  hasErrTransaction: false,
  profile: {},
  otp: { restOfCount: null },
  orders: null,
  advisorys: null,
  ip: null,
  nowActivity: {
  name: null,
 }
};

const user = {
  state,
  getters,
  mutations,
  actions
};

export default user;

